import React from 'react'

const Ref_usermanual = () => {

  return (
    <div style={{ width: '100%', height: '100vh',margin: 'auto' }}>
      <iframe src='https://privacypolicygodrejsmartlife.s3.ap-south-1.amazonaws.com/REF+-+Mobile+App+User+Manual_updated08072026.pdf'  title="PDF Viewer"
        width="100%"
        height="100%"
        style={{ border: 'none',overflow:'auto', backgroundColor:'white' }}></iframe>
    </div>
  )
}

export default Ref_usermanual;